import React, { useState } from 'react';

/**
 * Çmimet — i njëjti kalkulator dhe të njëjtat tekste si te landing-u i mëparshëm
 * (`landingContent.js` → `cmimet`, sq/en/de):
 *   deri 10 punonjës €15/muaj · 11–50: +€3 për secilin mbi 10 · mbi 50: ofertë
 *   vjetore: −20%.
 * Çmimi paraqitet si fletëpagesë — rreshtat që e përbëjnë, pastaj gjithsej —
 * që të shihet nga vjen shuma, jo vetëm sa është.
 * Deri në 50 butoni hap regjistrimin (demo 5 ditë); mbi 50, kërkesën për demonstrim.
 */

const EMP_MIN = 1;
const EMP_MAX = 100;

/** Çmimi mujor bazë, ose `null` mbi 50 punonjës (oferta personalizohet). */
export const monthlyBase = (n) => (n <= 50 ? 15 + Math.max(0, n - 10) * 3 : null);

export default function PricingSection({ cm, labels, onStart, onContact }) {
  const [emp, setEmp] = useState(10);
  const [yearly, setYearly] = useState(false);

  const clampEmp = (v) => Math.max(EMP_MIN, Math.min(EMP_MAX, v));
  const extra = Math.max(0, emp - 10);
  const base = monthlyBase(emp);
  const price = base ? (yearly ? Math.round(base * 0.8) : base) : null;

  return (
    <section id="cmimet" className="nxp-pricing" aria-labelledby="nxp-pricing-title">
      <div className="nxp-wrap">
        <div className="nxp-pricing-head">
          <h2 id="nxp-pricing-title" className="nxp-h2" tabIndex={-1} data-section-heading>{cm.title} {cm.titleHi}</h2>
          <p className="nxp-sub">{cm.subtitle}</p>
        </div>

        <div className="nxp-price-grid">
          <div className="nxp-calc">
            <label className="nxp-emp" htmlFor="nxp-emp-range">
              <span className="nxp-emp-label">{cm.employees}</span>
              <output className="nxp-emp-count" htmlFor="nxp-emp-range" aria-live="polite">{emp >= EMP_MAX ? `${EMP_MAX}+` : emp}</output>
            </label>
            <div className="nxp-emp-row">
              <button type="button" className="nxp-step-btn" aria-label={labels.minus} onClick={() => setEmp((v) => clampEmp(v - 1))} disabled={emp <= EMP_MIN}>−</button>
              <input
                id="nxp-emp-range"
                type="range"
                className="nxp-range"
                min={EMP_MIN}
                max={EMP_MAX}
                step="1"
                value={emp}
                onChange={(e) => setEmp(clampEmp(parseInt(e.target.value, 10) || EMP_MIN))}
                style={{ '--p': `${((emp - EMP_MIN) / (EMP_MAX - EMP_MIN)) * 100}%` }}
              />
              <button type="button" className="nxp-step-btn" aria-label={labels.plus} onClick={() => setEmp((v) => clampEmp(v + 1))} disabled={emp >= EMP_MAX}>+</button>
            </div>
            <ul className="nxp-tiers">
              <li className={emp <= 10 ? 'is-on' : ''}>{cm.sliderA}</li>
              <li className={emp > 10 && emp <= 50 ? 'is-on' : ''}>{cm.sliderB}</li>
              <li className={emp > 50 ? 'is-on' : ''}>{cm.sliderC}</li>
            </ul>

            <div className="nxp-billing" role="group" aria-label={labels.billing}>
              <button type="button" aria-pressed={!yearly} onClick={() => setYearly(false)}>{cm.monthly}</button>
              <button type="button" aria-pressed={yearly} onClick={() => setYearly(true)}>{cm.yearly} <span className="nxp-save">−20%</span></button>
            </div>
          </div>

          {/* Fletëpagesa e abonimit */}
          <div className="nxp-slip" aria-live="polite">
            <div className="nxp-slip-head">
              <span className="nxp-slip-title">{labels.slip}</span>
              <span>{yearly ? cm.yearly : cm.monthly}</span>
            </div>
            {base ? (
              <>
                <dl className="nxp-slip-lines">
                  <div><dt>{labels.lineBase}</dt><dd>€15</dd></div>
                  {extra > 0 && <div><dt>{labels.lineExtra(extra)}</dt><dd>€{extra * 3}</dd></div>}
                  {yearly && <div className="is-discount"><dt>{labels.lineYearly}</dt><dd>−€{base - price}</dd></div>}
                </dl>
                <div className="nxp-slip-total">
                  <span>{labels.total}</span>
                  <span className="nxp-price-num">€{price}</span>
                </div>
              </>
            ) : (
              <div className="nxp-slip-total is-offer">
                <span>{labels.bigNote}</span>
                <span className="nxp-price-num is-text">{cm.contactPrice}</span>
              </div>
            )}
            <p className="nxp-slip-note">{cm.inclBadge}</p>
            <button type="button" className="nxp-btn nxp-btn-primary nxp-btn-lg nxp-btn-block" onClick={base ? onStart : onContact}>
              {base ? cm.ctaTrial : cm.ctaContact}
            </button>
          </div>
        </div>

        <div className="nxp-incl">
          <h3 className="nxp-h3">{cm.includesTitle}</h3>
          <p className="nxp-muted">{cm.includesDesc}</p>
          <ul className="nxp-incl-grid">
            {cm.inclFeats.map((f) => <li key={f}>{f}</li>)}
          </ul>
          <p className="nxp-fine">{cm.bottomNote}</p>
        </div>
      </div>
    </section>
  );
}
